import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_StatusTag = _resolveComponent("StatusTag")!
  const _component_DataList = _resolveComponent("DataList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('intervention.title')) + " " + _toDisplayString(this.$route.params.id) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "interventionPreventive.definition" }),
        _createVNode(_component_ReglePastille, { cle: "suiviInterventionsPreventivesDetail.rapportDisponible" })
      ])
    ]),
    _createVNode(_component_BorderedIconButton, {
      title: "RETOUR",
      imgUrl: _ctx.imgUrl,
      className: "back-btn",
      onClick: this.$router.back
    }, null, 8, ["imgUrl", "onClick"]),
    _createVNode(_component_StatusTag, {
      status: this.status
    }, null, 8, ["status"]),
    (this.interventionData && this.isLoaded)
      ? (_openBlock(), _createBlock(_component_DataList, {
          key: 0,
          data: this.interventionData,
          onSelect: _ctx.goToPage,
          onDownloadPdf: _ctx.downloadPdf
        }, null, 8, ["data", "onSelect", "onDownloadPdf"]))
      : _createCommentVNode("", true)
  ]))
}